@if (reminderService.activeReminder(); as reminder) {
  <div class="reminder-overlay" role="alertdialog" aria-modal="true" aria-labelledby="reminder-type" aria-describedby="reminder-name">
    <div class="reminder-header">
      <span id="reminder-type" class="reminder-type">
        {{ reminder.reminderType === 'START' ? 'Start' : 'Stop' }}
        Live Assistant
      </span>
      <span id="reminder-name" class="meeting-name">{{ reminder.meetingSummary }}</span>
    </div>
    <div class="reminder-actions">
      @if (reminder.reminderType === 'START') {
        <button type="button" class="btn-primary" (click)="onStartSession(reminder.id)" [disabled]="isRequestPending(reminder.id)">
          Start Session
        </button>
      } @else {
        <button type="button" class="btn-primary" (click)="onStopSession(reminder.id)" [disabled]="isRequestPending(reminder.id)">
          Stop Session
        </button>
      }
      <button type="button" class="btn-secondary" (click)="onDismiss(reminder.id)" [disabled]="isRequestPending(reminder.id)">Dismiss</button>
    </div>
    <div class="snooze-menu">
      <button type="button" (click)="onSnooze('THIS_MEETING', reminder)" [disabled]="isRequestPending(reminder.id)">This meeting</button>
      <button type="button" (click)="onSnooze('THIS_DAY', reminder)" [disabled]="isRequestPending(reminder.id)">Today</button>
      <button type="button" (click)="onSnooze('THIS_WEEK', reminder)" [disabled]="isRequestPending(reminder.id)">This week</button>
      <button type="button" (click)="onSnooze('THIS_MONTH', reminder)" [disabled]="isRequestPending(reminder.id)">This month</button>
      <button type="button" (click)="onSnooze('FOREVER', reminder)" [disabled]="isRequestPending(reminder.id)">Forever</button>
    </div>
  </div>
}
